import "./App.css";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  ADMIN_DASHBOARD,
  CLIENT_LIST,
  DAILY_UPDATES,
  EMPLOYEE_LISTING,
  LOGIN,
  NOT_FOUND,
  PROJECT_LEAD,
  PROJECT_DETAILS,
  PROJECT_LIST,
  SETTING,
  CANDIDATE_LEAD,
  CANDIDATE_LEADS_DETAILS,
  PROJECT_LEAD_DETAILS,
  EMPLOYEE_DETAILS,
  EDIT_EMPLOYEE_DETAILS,
  ASSETS,
  ASSETS_DETAILS,
  EDIT_ASSETS_DETAILS,
  MY_TEAM,
  MY_TEAM_DETAILS,
  TASK_DETAILS,
  MY_TASK,
  PROJECT_TASK_DETAILS,
  PROJECT_TASK_REQUESTS,
  MY_TEAM_TASK_DETAILS,
  ORGANIZATION,
  INBOX,
  REPORT,
  CONNECT,
  MY_TEAM_RATING_PAGE,
  EMPLOYEE_RATING_DETAILS,
  TRAINING,
  TRAINING_DETAILS,
  TRAINING_LIST,
  BOOKS,
  DOCUMENT,
  MY_TRAINING,
  MY_TRAINING_DETAILS,
  TASK_DETAIL,
} from "./components/constans/Route";
import Login from "../src/components/auth/login/Login";
import RequireAuth from "./components/auth/RequireAuth.";
import AdminDashboard from "./views/admin/adminDashboard/AdminDashboard";
import NotFound from "./views/NotFound";
import { createContext, useEffect, useState } from "react";
import CheckAuth from "./components/auth/CheckAuth";
import EmployeeListing from "./views/admin/employeeList/EmployeeListing";
import secureLocalStorage from "react-secure-storage";
import Wrapper from "./components/common/Wrapper";
import ClientListing from "./views/admin/clientList/ClientListing";
import ProjectListing from "./views/admin/projectList/ProjectListing";
import Setting from "./views/admin/setting/Setting";
import DailyUpdates from "./views/admin/dailyUpdates/DailyUpdates";
import ProjectLead from "./views/admin/projectLead/ProjectLead";
import ProjectDetails from "./views/admin/ViewProject/ProjectDetails";
import CandidateLeads from "./views/admin/candidateleads/CandidateLeads";
import CandidateLeadsDetails from "./views/admin/candidateleads/CandidateLeadsDetails";
import ProjectLeadDetails from "./views/admin/projectLead/ProjectLeadDetails";
import EmployeeListDetails from "./views/admin/employeeList/EmployeeListDetails";
import EditEmployee from "./views/admin/employeeList/EditEmployee";
import Assets from "./views/admin/assetsPage/Assets";
import Assetsdetails from "./views/admin/assetsPage/AssetsDetails";
import EditAssetsDetail from "./views/admin/assetsPage/EditAssetsDetail";
import MyTeam from "./views/admin/myTeam/MyTeam";
import MyTeamDetail from "./views/admin/myTeam/MyTeamDetail";
import MyTask from "./views/admin/MyTask/MyTask";
import MyTaskDetails from "./views/admin/MyTask/MyTaskDetails";
import TaskDetail from "./views/admin/ViewProject/ProjectTask/TaskDetails";
import TrackerModal from "./views/TrackerModal";
import {
  GET_INBOX_COUNT,
  GET_MISSED_TASK_TIMER,
  SOCKET_IO_URL,
} from "./components/utils";
import { getRequest } from "./components/axiosClient";
import TasksRequest from "./views/admin/ViewProject/ProjectTask/TasksRequest";
import MyTeamTaskDetails from "./views/admin/myTeam/MyTeamTaskDetails";
import Organization from "./views/admin/organization/Organization";
import Inbox from "./views/admin/Inbox/Inbox";
// import { socket } from './views/socket';
import { io } from "socket.io-client";
import Report from "./views/admin/report/Report";
import Connect from "./views/admin/connect/Connect";
import MyTeamRatingView from "./views/admin/myTeam/MyTeamRatingView";
import EmployeeReviewDetails from "./views/admin/employeeList/EmployeeReviewDetails";
import Training from "./views/admin/training/Training";
import TrainingList from "./views/admin/training/TrainingList";
import TrainingDetails from "./views/admin/training/TrainingDetails";
import Document from "./views/admin/document/Document";
import BookList from "./views/admin/Books/BookList";
import MyTraining from "./views/admin/myTraining/MyTraining";
import MyTrainingDetails from "./views/admin/myTraining/MyTrainingDetails";
import TaskDetails from "./views/admin/taskDetails/TaskDetails";

export const boundaryContext = createContext();

function App() {
  const location = useLocation();
  const [locations, setLocations] = useState();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [navVisible, showNavbar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [myTeamEmployeeName, setMyTeamEmployeeName] = useState("");
  const [role_accesses, setRole_accesses] = useState([]);
  const [myTeamActiveRoute, setMyTeamActiveRoute] = useState("");
  const [myTaskActiveRoute, setMyTaskActiveRoute] = useState("");
  const [socket, setSocket] = useState(null);
  const [inboxCount, setInboxCount] = useState(0);
  const [boardView, setBoardView] = useState(true);
  const [leadBoardView, setLeadBoardView] = useState(false);
  // useEffect(() => {
  //   setLocations((location.pathname).slice(1))
  //   }, [location]);

  useEffect(() => {
    setLocations(location.pathname.slice(1));
    setRole(secureLocalStorage.getItem("role"));

    console.log("Set role", secureLocalStorage.getItem("role"));
    let myToken = secureLocalStorage.getItem("token");
    if (myToken === undefined || myToken === null) {
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
    }
    setLoading(false);
  }, [location]);

  useEffect(() => {
    let myToken = secureLocalStorage.getItem("token");
    const role_accesses1 = JSON.parse(
      secureLocalStorage.getItem("role_accesses")
    );

    if (myToken === undefined || myToken === null) {
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
      setRole_accesses(role_accesses1);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const navigate = useNavigate();

  const [showTrackerModal, setShowTrackerModal] = useState(false);

  useEffect(() => {
    const setupSocketConnection = async () => {
      if (!loggedIn) return; // Exit if not logged in

      // Ensure socket connection only happens if not already connected
      if (socket && socket.connected) return;

      // Retrieve the auth token
      let authToken = secureLocalStorage.getItem("token");

      if (!authToken) {
        console.error("No auth token found.");
        return;
      }

      // Initialize socket with authentication
      const socketIO = io(SOCKET_IO_URL, {
        extraHeaders: {
          Authorization: authToken,
        },
      });

      // Set up event listeners
      socketIO.on("connect", onConnect);
      socketIO.on("disconnect", onDisconnect);

      // Save socket instance
      setSocket(socketIO);

      // Fetch data once the socket is connected
      getTimeInfo();
      getInboxCount();
    };

    // Call async function inside useEffect
    setupSocketConnection();

    // Cleanup function: disconnect socket when logged out or component unmounts
    return () => {
      if (socket) {
        socket.off("connect", onConnect);
        socket.off("disconnect", onDisconnect);
        socket.disconnect(); // Disconnect the socket
      }
    };
  }, [loggedIn]);
  useEffect(() => {
    if (socket) {
      // Emit the 'getNotification' event
      socket.emit("getNotificationCount");

      // Listen for real-time data and handle the received message
      socket.on("getNotificationCount", (count) => {
        setInboxCount(count);
      });
    }

    // Cleanup on component unmount
    return () => {
      if (socket) {
        socket.off("getNotificationCount");
      }
    };
  }, [socket]);

  useEffect(() => {
    // this is to prevent the user from changing the value in the input type number field by mouse wheel
    const handleWheel = (event) => {
      if (
        event.target.type === "number" &&
        document.activeElement === event.target
      ) {
        event.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  // Function to handle socket connect
  const onConnect = () => {};

  // Function to handle socket disconnect
  const onDisconnect = () => {};
  const updateFavicon = (count) => {
    const favicon = document.querySelector("link[rel='icon']");
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const size = 64; // Favicon size

    canvas.height = size;

    // Draw the base favicon (your original icon)
    const img = new Image();
    // img.src = "/unikwork-logo.ico"; // Replace with your actual favicon path
    img.onload = () => {
      context.drawImage(img, 0, 0, size, size);

      if (count > 0) {
        // Draw the notification badge
        context.fillStyle = "red";
        context.beginPath();
        context.arc(size - 16, 16, 16, 0, Math.PI * 2); // Increased badge radius
        context.fill();

        // Add the notification count
        context.fillStyle = "white";
        context.font = "bold 20px Arial"; // Increased font size
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText(
          count > 99 ? "99+" : count, // Display "99+" for large numbers
          size - 16, // Center of the badge
          16 // Center of the badge
        );
      }

      // Update the favicon link
      favicon.href = canvas.toDataURL("image/png");
    };
  };

  useEffect(() => {
    if (inboxCount > 0 && loggedIn) {
      document.title = `New Notifications`;
      updateFavicon(inboxCount);
    } else {
      updateFavicon(0);
      document.title = "Dashboard";
    }
  }, [inboxCount, loggedIn]);

  const getInboxCount = async () => {
    try {
      let apiUrl;
      apiUrl = `${GET_INBOX_COUNT}`;
      const res = await getRequest(apiUrl, null, navigate);
      if (res.data && res.data.data) {
        setInboxCount(res.data.data.count);
      }
    } catch (error) {
      console.error("Error fetching tracker data:", error);
    }
  };

  const getTimeInfo = async () => {
    try {
      let apiUrl;
      apiUrl = `${GET_MISSED_TASK_TIMER}`;
      const res = await getRequest(apiUrl, null, navigate);
      if (res.data && res.data.data) {
        const data = res.data.data;
        if (data.length > 0) {
          setShowTrackerModal(true);
        } else {
          setShowTrackerModal(false);
        }
      }
    } catch (error) {
      console.error("Error fetching tracker data:", error);
    }
  };

  const routesData = [
    {
      id: 1,
      to: ADMIN_DASHBOARD,
      allowedRoles: [role],
      Component: AdminDashboard,
    },
    {
      id: 2,
      to: NOT_FOUND,
      allowedRoles: [role],
      Component: NotFound,
    },
    {
      id: 3,
      to: EMPLOYEE_LISTING,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Employee List")
          ?.access_type !== "None" && role,
      ],
      Component: EmployeeListing,
    },
    {
      id: 4,
      to: CLIENT_LIST,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Client")
          ?.access_type !== "None" && role,
      ],
      Component: ClientListing,
    },
    {
      id: 5,
      to: DAILY_UPDATES,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Daily Updates")
          ?.access_type !== "None" && role,
      ],
      Component: DailyUpdates,
    },
    {
      id: 6,
      to: PROJECT_LIST.split("?")[0],
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Projects")
          ?.access_type !== "None" && role,
      ],
      Component: ProjectListing,
    },
    {
      id: 7,
      to: PROJECT_LEAD,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Project Lead")
          ?.access_type !== "None" && role,
      ],
      Component: ProjectLead,
    },
    {
      id: 8,
      to: SETTING,
      allowedRoles: [role],
      Component: Setting,
    },
    {
      id: 9,
      to: PROJECT_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Projects")
          ?.access_type !== "None" && role,
      ],
      Component: ProjectDetails,
    },
    {
      id: 11,
      to: PROJECT_LEAD_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Project Lead")
          ?.access_type !== "None" && role,
      ],
      Component: ProjectLeadDetails,
    },
    {
      id: 12,
      to: CANDIDATE_LEAD,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Candidate Lead")
          ?.access_type !== "None" && role,
      ],
      Component: CandidateLeads,
    },
    {
      id: 13,
      to: CANDIDATE_LEADS_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Candidate Lead")
          ?.access_type !== "None" && role,
      ],
      Component: CandidateLeadsDetails,
    },
    {
      id: 14,
      to: EMPLOYEE_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Employee List")
          ?.access_type !== "None" && role,
      ],
      Component: EmployeeListDetails,
    },
    {
      id: 15,
      to: EDIT_EMPLOYEE_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Employee List")
          ?.access_type !== "None" && role,
      ],
      Component: EditEmployee,
    },
    {
      id: 10,
      to: ASSETS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Assets")
          ?.access_type !== "None" && role,
      ],
      Component: Assets,
    },
    {
      id: 17,
      to: ASSETS_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Assets")
          ?.access_type !== "None" && role,
      ],
      Component: Assetsdetails,
    },
    {
      id: 16,
      to: EDIT_ASSETS_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Assets")
          ?.access_type !== "None" && role,
      ],
      Component: EditAssetsDetail,
    },
    {
      id: 18,
      to: MY_TEAM,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Team")
          ?.access_type !== "None" && role,
      ],
      Component: MyTeam,
    },
    {
      id: 19,
      to: MY_TEAM_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Team")
          ?.access_type !== "None" && role,
      ],
      Component: MyTeamDetail,
    },
    {
      id: 20,
      to: TASK_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Task")
          ?.access_type !== "None" && role,
      ],
      Component: MyTaskDetails,
    },
    {
      id: 21,
      to: MY_TASK,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Task")
          ?.access_type !== "None" && role,
      ],
      Component: MyTask,
    },
    {
      id: 22,
      to: PROJECT_TASK_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Projects")
          ?.access_type !== "None" && role,
      ],
      Component: TaskDetail,
    },
    {
      id: 23,
      to: PROJECT_TASK_REQUESTS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Projects")
          ?.access_type !== "None" && role,
      ],
      Component: TasksRequest,
    },
    {
      id: 24,
      to: MY_TEAM_TASK_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Team")
          ?.access_type !== "None" && role,
      ],
      Component: MyTeamTaskDetails,
    },
    {
      id: 25,
      to: ORGANIZATION,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Organization")
          ?.access_type !== "None" && role,
      ],
      Component: Organization,
    },
    {
      id: 26,
      to: REPORT,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Report")
          ?.access_type !== "None" && role,
      ],
      Component: Report,
    },
    {
      id: 27,
      to: CONNECT,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Connect")
          ?.access_type !== "None" && role,
      ],
      Component: Connect,
    },
    {
      id: 28,
      to: INBOX,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Inbox")
          ?.access_type !== "None" && role,
      ],
      Component: Inbox,
    },
    {
      id: 29,
      to: TRAINING,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Training")
          ?.access_type !== "None" && role,
      ],
      Component: Training,
    },
    {
      id: 30,
      to: TRAINING_LIST,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Training")
          ?.access_type !== "None" && role,
      ],
      Component: TrainingList,
    },
    {
      id: 31,
      to: TRAINING_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Training")
          ?.access_type !== "None" && role,
      ],
      Component: TrainingDetails,
    },
    {
      id: 32,
      to: MY_TEAM_RATING_PAGE,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Team")
          ?.access_type !== "None" && role,
      ],
      Component: MyTeamRatingView,
    },
    {
      id: 33,
      to: EMPLOYEE_RATING_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Employee List")
          ?.access_type !== "None" && role,
      ],
      Component: EmployeeReviewDetails,
    },
    {
      id: 34,
      to: BOOKS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Books")
          ?.access_type !== "None" && role,
      ],
      Component: BookList,
    },
    {
      id: 35,
      to: DOCUMENT,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "Documents")
          ?.access_type !== "None" && role,
      ],
      Component: Document,
    },
    {
      id: 36,
      to: MY_TRAINING,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Training")
          ?.access_type !== "None" && role,
      ],
      Component: MyTraining,
    },
    {
      id: 37,
      to: MY_TRAINING_DETAILS,
      allowedRoles: [
        role_accesses.find((access) => access.module.name === "My Training")
          ?.access_type !== "None" && role,
      ],
      Component: MyTrainingDetails,
    },
    {
      id: 38,
      to: TASK_DETAIL,
      allowedRoles: [role],
      Component: TaskDetails,
    },
  ];

  return (
    <div>
      <Wrapper loading={loading}>
        <boundaryContext.Provider
          value={{
            profileImage,
            setProfileImage,
            projectName,
            setProjectName,
            employeeName,
            setEmployeeName,
            myTeamEmployeeName,
            setMyTeamEmployeeName,
            userData,
            setUserData,
            myTeamActiveRoute,
            setMyTeamActiveRoute,
            socket,
            setSocket,
            inboxCount,
            setInboxCount,
            myTaskActiveRoute,
            setMyTaskActiveRoute,
            boardView,
            setBoardView,
            leadBoardView,
            setLeadBoardView,
            role,
            setRole,
          }}
        >
          <Routes>
            <Route element={<CheckAuth loggedIn={loggedIn} role={role} />}>
              <Route path={LOGIN} element={<Login location={locations} />} />
            </Route>

            {routesData.map(({ allowedRoles, id, to, Component, show }) => {
              return (
                <Route
                  to={to}
                  key={id}
                  element={
                    <RequireAuth
                      show={show}
                      loggedIn={loggedIn}
                      allowedRoles={allowedRoles}
                      toggleSidebar={toggleSidebar}
                      isSidebarOpen={isSidebarOpen}
                      setSidebarOpen={setSidebarOpen}
                    />
                  }
                >
                  <Route path="*" element={<Navigate to={NOT_FOUND} />} />
                  <Route
                    path={to}
                    element={<Component />}
                    visible={navVisible}
                    show={showNavbar}
                  />
                </Route>
              );
            })}
          </Routes>
          {showTrackerModal && (
            <TrackerModal onClose={() => setShowTrackerModal(false)} />
          )}
        </boundaryContext.Provider>
      </Wrapper>
    </div>
  );
}

export default App;
